module.exports = __webpack_public_path__ + "img/image-example3.51199300.png";